<template>
  <div class="member-bar">
    <template v-if="member">
      <a-icon type="crown" class="member-icon" />
      <span class="member-name">{{ member.contacts || member.cardNo }}</span>
      <span class="member-level">{{ member.levelName || '会员' }}</span>
      <a-icon type="close" class="member-clear" title="清除会员（散客）" @click="$emit('clear')" />
    </template>
    <template v-else>
      <a-input-search ref="searchInput" v-model="keyword" placeholder="扫会员码 / 输入手机号、姓名、卡号定位会员"
                       enterButton="定位会员" @search="onSearch" />
      <span class="guest-tip">当前散客</span>
    </template>
  </div>
</template>

<script>
  import { cashierMemberSearch } from '@/api/plugin/member'

  /**
   * 会员条：会员码/手机号/姓名定位会员，散客一键清除
   */
  export default {
    name: 'MemberBar',
    props: {
      member: { type: Object, default: null }
    },
    data() {
      return {
        keyword: ''
      }
    },
    methods: {
      onSearch() {
        const kw = (this.keyword || '').trim()
        if (!kw) {
          this.$message.warning('请输入会员码或手机号/姓名/卡号')
          return
        }
        cashierMemberSearch(kw).then(res => {
          if (res && res.code === 200) {
            const list = res.data || []
            if (!list.length) {
              this.$message.warning('未找到会员')
              return
            }
            this.$emit('located', list[0])
            this.keyword = ''
          } else {
            this.$message.warning((res && res.message) || '查询失败')
          }
        })
      },
      focus() {
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus()
          }
        })
      }
    }
  }
</script>

<style scoped>
  .member-bar {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 8px 12px;
    gap: 10px;
  }
  .member-bar .ant-input-search {
    flex: 1;
  }
  .member-icon {
    color: #faad14;
    font-size: 18px;
  }
  .member-name {
    font-size: 15px;
    font-weight: 600;
    color: #333;
  }
  .member-level {
    color: #0081ff;
    border: 1px solid #0081ff;
    border-radius: 3px;
    font-size: 12px;
    padding: 0 6px;
  }
  .member-clear {
    color: #999;
    cursor: pointer;
    margin-left: auto;
    font-size: 14px;
  }
  .member-clear:hover {
    color: #e4393c;
  }
  .guest-tip {
    color: #999;
    font-size: 12px;
  }
</style>
